<template>
  <h4
    class="icon-cart pointer mx-15 mr-5-sm mt-5-sm mb-10-sm text-center"
    style="width: 32px; height: 32px; font-size: 11px; padding-left: 3px; padding-top: 7px"
    @click="$route.name && $route.name.includes('checkout') ? null : $emit('toggle-cart')"
    data-cy="cart-button"
  >
    {{ count }}
  </h4>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "CartButton",
  computed: {
    ...mapGetters({
      count: "cart/count",
    }),
  },
};
</script>
